export default __webpack_public_path__ + "static/media/property_278.68e4bf35.png";